import React, { useCallback, useState } from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import { getCityBrandAmbassadorsMinimal } from '../../Containers/City/Page/Ambasadors/gql'
import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'
import { BRAND_AMBASSADOR_STATUS_ENUM } from '../../shared/constants'
import { debounce } from '../../Utils/Functions'

const loadingLabel = 'Loading...'

const SmartBASearch = ({
  cityId,
  onSelect,
  selectedUser,
  disabled = false,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [brandAmbassadors, setBrandAmbassadors] = useState(() =>
    selectedUser ? [selectedUser] : [],
  )

  const getAmbassadors = useCallback(
    debounce(async search => {
      setIsLoading(true)
      if (
        search.length < 2 ||
        (selectedUser &&
          `${selectedUser.firstName} ${selectedUser.lastName}` === search)
      ) {
        return
      }

      const response = await callAuthorizedGraphQLEndpoint(
        getCityBrandAmbassadorsMinimal,
        {
          cityId,
          statuses: [BRAND_AMBASSADOR_STATUS_ENUM.ACTIVE],
          search,
        },
      )

      const result = (await response.json()).data.city.brandAmbassadors.nodes

      setBrandAmbassadors(result)
      setIsLoading(false)
    }, 500),
    [cityId, selectedUser],
  )

  return (
    <div>
      <Autocomplete
        id="combo-box-demo"
        onInputChange={(event, search) => {
          getAmbassadors(search)
        }}
        onChange={(event, user) => {
          onSelect(user)
        }}
        defaultValue={selectedUser}
        options={isLoading ? [loadingLabel] : brandAmbassadors}
        getOptionLabel={option =>
          option === loadingLabel
            ? loadingLabel
            : `${option.firstName} ${option.lastName}`
        }
        getOptionDisabled={option => option === loadingLabel}
        style={{ width: 200, position: 'relative' }}
        renderInput={params => (
          <TextField {...params} label="BA" variant="outlined" />
        )}
        disableClearable
        disabled={disabled}
      />
    </div>
  )
}

export default SmartBASearch
